import { useEffect, useState } from 'react';
import classes from './LoginPage.module.css';

const INTERVAL_MS = 5000;

function slideUrl(src) {
  const base = process.env.PUBLIC_URL || '';
  return src.startsWith('/') ? `${base}${src}` : `${base}/${src}`;
}

export default function LoginHeroCarousel() {
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let cancelled = false;

    fetch('/api/login-carousel/slides')
      .then((r) => r.json())
      .then((d) => {
        if (cancelled || !d.success || !Array.isArray(d.data)) return;
        setSlides(d.data);
        setIndex(0);
      })
      .catch(() => {
        if (!cancelled) setSlides([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (slides.length <= 1) return undefined;

    const timer = setInterval(
      () => setIndex((current) => (current + 1) % slides.length),
      INTERVAL_MS,
    );
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextIndex = slides.length > 1 ? (index + 1) % slides.length : index;
  const prevIndex = slides.length > 1 ? (index - 1 + slides.length) % slides.length : index;

  return (
    <div className={classes.carousel} aria-hidden="true">
      {slides.map((slide, i) => {
        const active = i === index;
        if (i !== index && i !== nextIndex && i !== prevIndex) return null;

        return (
          <img
            key={slide.src}
            className={`${classes.carouselSlide} ${active ? classes.carouselSlideActive : ''}`}
            src={slideUrl(slide.src)}
            alt=""
            decoding="async"
            loading={i === 0 ? 'eager' : 'lazy'}
            fetchPriority={active ? 'high' : 'low'}
          />
        );
      })}
      <div className={classes.heroOverlay} />
    </div>
  );
}
